import './Navigation.css'

const logoSrc: string="https://adammagnusson.se/files/am.png"

function Navigation() {
  return (
    <div className="Navigation">
      <a className="Logo" href='/'>
        <img 
          src={logoSrc}
          alt="logo"
        />
      </a>
    </div>
  );
}

export default Navigation;
